import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Icon,
  IconVariant,
  Space,
} from '@gousto-internal/citrus-react'
import { RadiusScale } from '@gousto-internal/citrus-react/dist/theme/tokens'

import { useTimeLeftToCheckOut } from 'routes/Checkout/Components/CheckoutUrgency/checkoutUrgencyUtils'

/**
 * Displays banner during every check out step saying "Checkout within {timeLeft} to avoid losing your recipes".
 */
export const UrgencyBanner = () => {
  const timeLeft = useTimeLeftToCheckOut()

  return (
    <Box paddingV={[2, 4, 8]} paddingH={[2, 0, 8]}>
      <Box
        display="flex"
        bg={Color.Warning_50}
        borderStyle={BorderStyle.Solid}
        borderColor={Color.Warning_100}
        borderWidth={0.5}
        borderRadius={3 as RadiusScale}
        paddingV={2}
        paddingH={2}
        alignItems={AlignItems.Center}
      >
        <Icon name="time" variant={IconVariant.Error} />

        <Space size={1} direction="horizontal" />
        <Box paddingV={1}>Checkout within {timeLeft} to avoid losing your recipes</Box>
      </Box>
    </Box>
  )
}
